import React from 'react'
import classes from "./Fifth.module.scss"
import Button from '../../GlobalComponents/Button/Button'

const Fifth = () => {
    return (
        <div className={[classes.second, ""].join(" ")}>
            <div className={[classes.secondBody, ""].join(" ")}>
                <div className={[classes.secondRow, ""].join(" ")}>
                    <div className={[classes.secondRowLeft, ""].join(" ")}>
                        <h2 className={[classes.secondRowLeftTitle, ""].join(" ")}>
                            Qualified personal care for all breeds
                        </h2>
                        <p className={[classes.secondRowLeftSubtitle, ""].join(" ")}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at.
                        </p>
                        <div className={[classes.secondRowLeftBtn, ""].join(" ")}>
                            <Button>Discover</Button>
                        </div>


                    </div>
                    <div className={[classes.secondRowRight, ""].join(" ")}>
                        <div className={[classes.secondRowRightTitle, ""].join(" ")}>
                            All full grooms include
                        </div>
                        <ul className={[classes.secondRowRightList, ""].join(" ")}>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                A Warm Massage Jet Wash
                            </li>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                Fluff Dry
                            </li>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                Nails Trimmed
                            </li>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                Paw Pads Shaved
                            </li>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                Ear Cleaning

                            </li>
                            <li className={[classes.secondRowRightListItem, ""].join(" ")}>
                                Haircut of Choice
                            </li>
                        </ul>


                    </div>

                </div>

            </div>

        </div>
    )
}

export default Fifth